import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class EstudioCientificoService {

	constructor(private http: HttpClient) {}

	getAllCentersEstudio(): Observable<any> {
		return this.http.get<any>('estudio-cientifico/centers');
	}

	getCenterDetail(idCenter: number): Observable<any> {
		return this.http.get<any>(`estudio-cientifico/center/${idCenter}`);
	}

	getGruposByCenter(idCenter: number): Observable<any> {
		return this.http.get<any>(`estudio-cientifico/center/${idCenter}/groups`);
	}

	getProfesoresByCenter(idCenter: number): Observable<any> {
		return this.http.get<any>(`estudio-cientifico/center/${idCenter}/teachers`);
	}

	getMandosByCenter(idCenter: number): Observable<any> {
		return this.http.get<any>(`estudio-cientifico/center/${idCenter}/mandos`);
	}

	updateCenter(idCenter: number, data: any): Observable<any> {
		return this.http.put<any>(`estudio-cientifico/center/${idCenter}`, data);
	}

	getDashboardTeacher(idGroup: number, idUser: number, period: string = 'all'): Observable<any> {
		return this.http.get<any>(`estudio-cientifico/group/${idGroup}/teacher/${idUser}/dashboard?period=${period}`);
	}

	getDashboardGroup(idGroup: number, period: string = 'all'): Observable<any> {
		return this.http.get<any>(`estudio-cientifico/group/${idGroup}/dashboard?period=${period}`);
	}

	getDashboardCenter(idCenter: number, period: string = 'all'): Observable<any> {
		return this.http.get<any>(`estudio-cientifico/center/${idCenter}/dashboard?period=${period}`);
	}

	getDashboardTeacherInCenter(idCenter: number, idUser: number, period: string = 'all'): Observable<any> {
		return this.http.get<any>(`estudio-cientifico/center/${idCenter}/teacher/${idUser}/dashboard?period=${period}`);
	}

	getDashboardGlobal(period: string = 'all'): Observable<any> {
		return this.http.get<any>(`estudio-cientifico/dashboard/global?period=${period}`);
	}
}
